import type { ReactNode } from 'react';
import { BrandLockup } from '@/components/BrandMark';

export function AuthCard({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <BrandLockup />
        {children}
      </div>
    </div>
  );
}
